import React from 'react';
import cx from 'classnames';

var PureRenderMixin = React.addons.PureRenderMixin;


var Image = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    width: React.PropTypes.number.isRequired,
    height: React.PropTypes.number.isRequired,
    url: React.PropTypes.string.isRequired
  },

  getInitialState() {
    return {
      loaded: false,
      loadingImage: null,
      alreadyLoaded: false          
    };
  },

  handleImageLoad() {
    if (this.state.loadingImage) {
      this.state.loadingImage.removeEventListener('load', this.handleImageLoad);
      this.state.loadingImage.remove();

      this.setState({
        loaded: true,
        loadingImage: null
      });
    }
  },

  componentDidMount() {
    var el = this.getDOMNode();
    var width = el.getBoundingClientRect().width;
    var scale = width / this.props.width;

    var img = document.createElement('img');
    img.addEventListener('load', this.handleImageLoad);

    img.src = this.props.url;

    this.setState({
      'alreadyLoaded': img.complete,
      'loadingImage': img,
      'scale': scale
    });
  },

  componentWillUnmount() {
    if (this.state.loadingImage) {
      this.state.loadingImage.removeEventListener('load', this.handleImageLoad);
      this.state.loadingImage.remove();
    }
  },

  render() {
    var {url, width, height, ...props} = this.props;
    var {scale, loaded} = this.state;
    var ratio = width / height;

    var classes = cx(
      `ofs-Image`,
      `ofs-Image--${loaded ? 'loaded' : 'loading'}`
    );

    return (
      <div className={classes}>
        <div className="ofs-Image__Background">
          <img className="ofs-Image__Image" width={scale && Math.round(width * scale)} height={scale && Math.round(height * scale)} style={{opacity: loaded ? 100 : 0}} src={url} {...props} />
        </div>
      </div>
    );
  }
});

export default Image;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/common/Image.jsx
 **/